import { SPACE_ICON_ID_PREFIX } from '#pplx/frontend/apps/ask/queries/spaces-queries/constants.js';
/** Served symbol id for a bare catalog name persisted in Appearance.icon. */
export function getSpaceIconId(iconName) {
    return `${SPACE_ICON_ID_PREFIX}${iconName}`;
}
//# sourceMappingURL=getSpaceIconId.js.map